module.exports = __webpack_public_path__ + "static/media/thewest-banner-black-friday.65a87667.png";